module.exports = __webpack_public_path__ + "img/ug.ug9e26c8f.svg";